import styles from './styles.scss';
import { SuggestedCategory } from 'models/SuggestedCategory';
import cn from 'classnames';
import Image from 'components/Shared/Image';
import { BhImageType } from 'models/BhImageType';
import { NotifyLink } from 'components/Shared/NotifyLink';

interface OwnProps {
  categoryData: SuggestedCategory;
  selected?: boolean;
  onSelect: () => void;
  txtProducts: string;
}

const PRODUCT_IMAGE_HEIGHT = 100;
const PRODUCT_IMAGE_WIDTH = 170;

export default ({ categoryData, onSelect, txtProducts, selected }: OwnProps) => (
  <div className={cn(styles.category, selected ? styles.selected : '', styles.brandinfoholder)}>
    <div className={styles.brandlogoholder}>
      <NotifyLink url={categoryData.url} ticket={categoryData.ticket} onClick={onSelect}>
        <Image
          {...{
            type: BhImageType.Product,
            id: categoryData.imageGuid,
            name: categoryData.imageName,
            height: PRODUCT_IMAGE_HEIGHT,
            width: PRODUCT_IMAGE_WIDTH,
            alt: categoryData.displayName
          }}
        />
      </NotifyLink>
    </div>
    <NotifyLink url={categoryData.url} ticket={categoryData.ticket} onClick={onSelect}>
      {categoryData.displayName}
    </NotifyLink>
    <p className={styles.productcount}>
      {categoryData.productCount} {txtProducts}
    </p>
    <ul>
      {categoryData.categories.map((subcategory, index) => (
        <li key={index}>
          <NotifyLink url={subcategory.url} ticket={subcategory.ticket} onClick={onSelect}>
            » {subcategory.displayName}
          </NotifyLink>
        </li>
      ))}
    </ul>
  </div>
);
